import { render, staticRenderFns } from "./BottomLedge.vue?vue&type=template&id=7908eb3a&scoped=true&"
import script from "./BottomLedge.vue?vue&type=script&lang=js&"
export * from "./BottomLedge.vue?vue&type=script&lang=js&"
import style0 from "./BottomLedge.vue?vue&type=style&index=0&id=7908eb3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7908eb3a",
  null
  
)

export default component.exports